import { equals, keys, length, not, pipe, map, isNil, any, gte } from 'ramda';

export const hasErrors = pipe(keys, length, equals(0), not);

export const getErrors = (errors, name) => errors[name] && errors[name].join(',');

/**
 * If one of values are null or undefined return false instead true.
 * @param {Array} values
 * @returns Boolean
 */
export const hasNilValues = values => any(equals(true), map(isNil, values));

const maxLength = max => pipe(length, gte(max));

export const maxLengthValidator = (max, errorMessage = 'The maximum length of value is %s.') => value =>
  maxLength(max)(value) ? undefined : errorMessage.replace('%s', max);

export const PHONE_REGEX = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[-. \\]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?$/gim;
